'use strict';

angular.module('vm', ['vcRecaptcha', 'pascalprecht.translate', 'mgcrea.ngStrap', 'ngCookies', 'ngSanitize', 'ngPasswordMeter', 'ui.bootstrap', 'vm.common']).config(function ($translateProvider) {
    $translateProvider.fallbackLanguage('en');
}).filter('passwordToAsterisk', function () {
    return function (input) {
        var output = '';

        for (var i = 0; i <= input.length; i++) {
            output += '*';
        }

        return output;
    };
}).run(function ($injector) {
    window.injector = $injector;
});
'use strict';

(function () {
    'use strict';

    angular.module('vm').factory('LangSelectorModal', LangSelectorModal);

    function LangSelectorModal($modal, $rootScope, $http) {
        var modalScope = $rootScope.$new(true);
        var vm = modalScope.vm = {};

        vm.domains = null;
        vm.changeLanguage = changeLanguage;

        return {
            show: show
        };

        //////////////

        function show() {
            getDomains();

            $modal({
                templateUrl: 'lang-selector-modal.html',
                show: true,
                scope: modalScope
            });
        }

        function getDomains() {
            $http.get('/api/v4.0/service/domain-links.json?type=mweb').then(function (response) {
                vm.domains = response.data;
            });
        }

        function changeLanguage(locale) {
            var newUrl,
                curUrl = window.location.href;

            if (/\/([a-z]{2}|[a-z]{2}_[A-Z]{2}|zh_Hans_[A-Z]{2})\//.test(curUrl)) {
                newUrl = curUrl.replace(/\/([a-z]{2}|[a-z]{2}_[A-Z]{2}|zh_Hans_[A-Z]{2})\//g, '/' + locale + '/');
            } else {
                newUrl = curUrl.replace(/^(https?.\/\/(\w+\.)+\w+)\/(.*)$/, '$1/' + locale + '/$3');
            }

            window.location.href = newUrl;
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('vm').factory('SignupFetchErrorMessage', SignupFetchErrorMessage);

    function SignupFetchErrorMessage($translate) {
        return function (response) {
            var message = '';

            if (angular.isDefined(response.errors)) {
                if (response.errors === null) {
                    message = response.message;
                } else if (angular.isString(response.errors)) {
                    message = response.errors;
                } else {
                    angular.forEach(response.errors.children, function (value, key) {
                        if (angular.isDefined(value.errors)) {
                            message += {
                                "name": $translate.instant('common.username_label') + ": ",
                                "email": $translate.instant('common.email') + ": ",
                                "password": $translate.instant('common.password_label') + ": ",
                                "sex": "Sex: ",
                                "birthDate": $translate.instant('common.birthday_label') + ": "
                            }[key];

                            message += value.errors.join(' ') + '<br/>';
                        }
                    });

                    if (angular.isDefined(response.errors.errors)) {
                        message += response.errors.errors.join('');
                    }
                }
            }

            return message;
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('vm').factory('DomainSettings', DomainSettings);

    function DomainSettings($http, CONFIG) {
        var domainSettingsPromise = void 0;

        return {
            clean: clean,
            get: get,
            reload: reload
        };

        //////////////

        function clean() {
            domainSettingsPromise = null;
        }

        function get() {
            if (!domainSettingsPromise) {
                domainSettingsPromise = $http.get('/api/v4.0/service/domain-settings.json').then(function (response) {
                    return angular.extend({}, CONFIG.defaultDomainSettings, response.data);
                }).catch(function () {
                    return CONFIG.defaultDomainSettings;
                });
            }

            return domainSettingsPromise;
        }

        function reload() {
            clean();
            get();
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('vm').factory('BrowserOauth', BrowserOauth);

    function BrowserOauth($q, DOMAIN_SETTINGS, CONFIG) {
        return {
            auth: auth,
            getAuthUrl: getAuthUrl
        };

        //////////////

        function auth(provider) {
            return new $q(function (resolve, reject) {
                getAuthUrl(provider).then(function (authUrl) {
                    var authWindow = window.open(authUrl);

                    var interval = setInterval(function () {
                        try {
                            var url = authWindow.location.href;

                            if (url && url.includes('/oauth.html')) {
                                var callbackResponse = authWindow.location.hash.split('#')[1];
                                var responseParameters = callbackResponse.split('&');
                                var parameterMap = {};

                                for (var i = 0; i < responseParameters.length; i++) {
                                    parameterMap[responseParameters[i].split('=')[0]] = responseParameters[i].split('=')[1];
                                }

                                clearInterval(interval);
                                authWindow.close();

                                if (parameterMap.access_token) {
                                    var token = {
                                        access_token: parameterMap.access_token,
                                        expires_in: parseInt(parameterMap.expires_in),
                                        created_at: new Date()
                                    };

                                    resolve(token);
                                } else {
                                    reject('problem authenticating');
                                }
                            }
                        } catch (e) {}
                    }, 1000);
                });
            });
        }

        function getAuthUrl(provider) {
            var redirectLocation = [window.location.protocol, '//', window.location.host, '/oauth.html'].join('');

            return new $q(function (resolve) {
                var providers = {
                    facebook: {
                        authenticate: 'https://www.facebook.com/v2.0/dialog/oauth?client_id=' + DOMAIN_SETTINGS.facebookClientId + '&redirect_uri=' + redirectLocation + '&response_type=token&scope=' + CONFIG.oAuthProviders.facebook.appScope.join(',')
                    },
                    instagram: {
                        authenticate: 'https://api.instagram.com/oauth/authorize/?client_id=' + DOMAIN_SETTINGS.instagramClientId + '&redirect_uri=' + redirectLocation + '&response_type=token&scope=' + CONFIG.oAuthProviders.instagram.appScope.join('+')
                    },
                    windows_live: {
                        authenticate: 'https://login.live.com/oauth20_authorize.srf?client_id=' + DOMAIN_SETTINGS.windowsLiveClientId + "&scope=" + CONFIG.oAuthProviders.windowsLive.appScope.join('+') + '&response_type=token&display=touch&redirect_uri=' + redirectLocation
                    },
                    google: {
                        authenticate: 'https://accounts.google.com/o/oauth2/auth?client_id=' + DOMAIN_SETTINGS.googleClientId + '&redirect_uri=' + redirectLocation + '&scope=' + CONFIG.oAuthProviders.google.appScope.join(' ') + '&approval_prompt=force&response_type=token'
                    }
                };

                resolve(providers[provider].authenticate);
            });
        }
    }
})();
'use strict';

angular.module('vm').factory('CursorWait', CursorWait);

function CursorWait() {
    return {
        enable: enable,
        disable: disable
    };

    //////////////

    function enable() {
        document.body.classList.add('cursor-wait');
    }

    function disable() {
        document.body.classList.remove('cursor-wait');
    }
}
'use strict';

angular.module('vm').factory('DateSelect', DateSelect);

function DateSelect($translate) {
    return {
        getDays: getDays,
        getMonths: getMonths,
        getYears: getYears
    };

    //////////////

    function getDays(maxDate) {
        var days = [];

        if (!maxDate) {
            var maxDate = 31;
        }

        for (var day = 1; day <= maxDate; day++) {
            var fullDay = day.toString();

            if (day < 10) {
                fullDay = '0' + fullDay;
            }

            days.push({
                id: fullDay,
                text: fullDay
            });
        }

        return days;
    }

    function getMonths() {
        return [{
            id: '01',
            text: $translate.instant('common.date.january')
        }, {
            id: '02',
            text: $translate.instant('common.date.february')
        }, {
            id: '03',
            text: $translate.instant('common.date.march')
        }, {
            id: '04',
            text: $translate.instant('common.date.april')
        }, {
            id: '05',
            text: $translate.instant('common.date.may')
        }, {
            id: '06',
            text: $translate.instant('common.date.june')
        }, {
            id: '07',
            text: $translate.instant('common.date.july')
        }, {
            id: '08',
            text: $translate.instant('common.date.august')
        }, {
            id: '09',
            text: $translate.instant('common.date.september')
        }, {
            id: '10',
            text: $translate.instant('common.date.october')
        }, {
            id: '11',
            text: $translate.instant('common.date.november')
        }, {
            id: '12',
            text: $translate.instant('common.date.december')
        }];
    }

    function getYears() {
        var years = [];
        var now = new Date();
        var minYear = now.getFullYear() - 100;
        var maxYear = now.getFullYear() - 18;

        for (var year = maxYear; year >= minYear; year--) {
            years.push({
                id: '' + year,
                text: '' + year
            });
        }

        return years;
    }
}
'use strict';

angular.module('vm').factory('RelationshipStatusSelect', RelationshipStatusSelect);

function RelationshipStatusSelect($translate) {
    var MARRIED_MAN_SEEKING_WOMAN = 0,
        MARRIED_WOMAN_SEEKING_MAN = 1,
        ATTACHED_MAN_SEEKING_WOMAN = 2,
        ATTACHED_WOMAN_SEEKING_MAN = 3,
        SINGLE_MAN_SEEKING_WOMAN = 4,
        SINGLE_WOMAN_SEEKING_MAN = 5,
        MAN_SEEKING_MAN = 6,
        WOMAN_SEEKING_WOMAN = 7,
        DIVORCED_MAN_SEEKING_WOMAN = 8,
        DIVORCED_WOMAN_SEEKING_MAN = 9;

    var SEX_MALE = 'male',
        SEX_FEMALE = 'female';

    var SINGLE = 'single',
        SEPARATED = 'separated',
        MARRIED = 'married',
        DIVORCED = 'divorced',
        WIDOWED = 'widowed',
        ATTACHED = 'attached';

    return {
        getUserDefinitionVM: getUserDefinitionVM,
        getUserDefinitionMap: getUserDefinitionMap
    };

    //////////////

    function getUserDefinitionVM() {
        return [{
            id: MARRIED_MAN_SEEKING_WOMAN,
            text: $translate.instant('married_man_seeking_a_woman'),
            sex: 'man'
        }, {
            id: MARRIED_WOMAN_SEEKING_MAN,
            text: $translate.instant('married_woman_seeking_a_man'),
            sex: 'woman'
        }, {
            id: ATTACHED_MAN_SEEKING_WOMAN,
            text: $translate.instant('attached_man_seeking_a_woman'),
            sex: 'man'
        }, {
            id: ATTACHED_WOMAN_SEEKING_MAN,
            text: $translate.instant('attached_woman_seeking_a_man'),
            sex: 'woman'
        }, {
            id: SINGLE_MAN_SEEKING_WOMAN,
            text: $translate.instant('single_man_seeking_a_woman'),
            sex: 'man'
        }, {
            id: SINGLE_WOMAN_SEEKING_MAN,
            text: $translate.instant('single_woman_seeking_a_man'),
            sex: 'woman'
        }, {
            id: MAN_SEEKING_MAN,
            text: $translate.instant('man_seeking_a_man'),
            sex: 'man'
        }, {
            id: WOMAN_SEEKING_WOMAN,
            text: $translate.instant('woman_seeking_a_woman'),
            sex: 'woman'
        }];
    }

    function getUserDefinitionNL() {
        return [];
    }

    function getUserDefinitionMap() {
        return [MARRIED_MAN_SEEKING_WOMAN = {
            'sex': SEX_MALE,
            'seekingSex': SEX_FEMALE,
            'relationshipStatus': MARRIED
        }, MARRIED_WOMAN_SEEKING_MAN = {
            'sex': SEX_FEMALE,
            'seekingSex': SEX_MALE,
            'relationshipStatus': MARRIED
        }, ATTACHED_MAN_SEEKING_WOMAN = {
            'sex': SEX_MALE,
            'seekingSex': SEX_FEMALE,
            'relationshipStatus': ATTACHED
        }, ATTACHED_WOMAN_SEEKING_MAN = {
            'sex': SEX_FEMALE,
            'seekingSex': SEX_MALE,
            'relationshipStatus': ATTACHED
        }, SINGLE_MAN_SEEKING_WOMAN = {
            'sex': SEX_MALE,
            'seekingSex': SEX_FEMALE,
            'relationshipStatus': SINGLE
        }, SINGLE_WOMAN_SEEKING_MAN = {
            'sex': SEX_FEMALE,
            'seekingSex': SEX_MALE,
            'relationshipStatus': SINGLE
        }, MAN_SEEKING_MAN = {
            'sex': SEX_MALE,
            'seekingSex': SEX_MALE,
            'relationshipStatus': SINGLE
        }, WOMAN_SEEKING_WOMAN = {
            'sex': SEX_FEMALE,
            'seekingSex': SEX_FEMALE,
            'relationshipStatus': SINGLE
        }, DIVORCED_MAN_SEEKING_WOMAN = {
            'sex': SEX_MALE,
            'seekingSex': SEX_FEMALE,
            'relationshipStatus': DIVORCED
        }, DIVORCED_WOMAN_SEEKING_MAN = {
            'sex': SEX_FEMALE,
            'seekingSex': SEX_MALE,
            'relationshipStatus': DIVORCED
        }];
    }
}
'use strict';

(function () {

    angular.module('vm').service('$api', $api);

    function $api($http) {

        return {
            get: get,
            delete: _delete,
            patch: patch,
            post: post,
            put: put,
            getFullUrl: getFullUrl
        };

        /////////////////

        function get(path, options) {
            return $http.get(getFullUrl(path), options);
        }

        function post(path, parameters, options) {
            return $http.post(getFullUrl(path), parameters, options);
        }

        function _delete(path) {
            return $http.delete(getFullUrl(path));
        }

        function patch(path, parameters, options) {
            return $http.patch(getFullUrl(path), parameters, options);
        }

        function put(path, parameters, options) {
            return $http.put(getFullUrl(path), parameters, options);
        }

        function getFullUrl(path) {
            return '/api/v4.0/' + path;
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('vm').factory('Auth', Auth);

    function Auth($api, BrowserOauth, $cookies) {
        return {
            oAuthLogin: oAuthLogin,
            redirectToFrontend: redirectToFrontend
        };

        //////////////

        function oAuthLogin(provider) {
            return BrowserOauth.auth(provider).then(function (token) {
                var url = 'oauth-hybrid-auth.json' + '?service=' + provider + '&token=' + token.access_token + '&expirationTime=' + token.expires_in;

                return $api.get(url).then(function (response) {
                    return response.data;
                });
            });
        }

        function redirectToFrontend(token) {
            var cookieOptions = {
                path: '/'
            };

            try {
                $cookies.remove('preferV4', cookieOptions);
                $cookies.remove('preferMobile', cookieOptions);
            } catch (e) {}

            if (getScreenWidth() < 1000) {
                $cookies.put('preferMobile', 'true', cookieOptions);

                window.location.href = '/?nc#/auto-login?token=' + token;
            } else {
                $cookies.put('preferV4', 'true', cookieOptions);

                window.location.href = '/?nc#/auto-login;token=' + token;
            }
        }

        function getScreenWidth() {
            try {
                return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            } catch (err) {
                console.error(err);
                return 0;
            }
        }
    }
})();
'use strict';

angular.module('vm').component('appLangSelector', {
    templateUrl: 'lang-selector.component.html',
    bindings: {},
    controllerAs: 'vm',
    controller: function controller(LangSelectorModal) {
        var vm = this;

        vm.showLangSelector = showLangSelector;

        /////////////

        function showLangSelector() {
            LangSelectorModal.show();
        }
    }
});
'use strict';

(function () {
    'use strict';

    angular.module('vm').factory('Notifications', Notifications);

    function Notifications() {
        var onNotificationAdd;

        return {
            add: add,
            setOnNotificationAdd: setOnNotificationAdd
        };

        //////////////

        function add(notificationData) {
            if (onNotificationAdd) {
                onNotificationAdd(notificationData);
            }
        }

        function setOnNotificationAdd(fn) {
            onNotificationAdd = fn;
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('vm').component('appNotifications', {
        templateUrl: 'notifications.component.html',
        bindings: {},
        controllerAs: 'vm',
        controller: function controller(Notifications, $timeout) {
            var vm = this;

            vm.notifications = [];
            vm.$onInit = $onInit;
            vm.removeNotification = removeNotification;

            //////////

            function $onInit() {
                Notifications.setOnNotificationAdd(onNotificationAdd.bind(this));
            }

            function onNotificationAdd(notification) {
                vm.notifications.push(notification);

                $timeout(function () {
                    removeNotification(notification);
                }, 5000);
            }

            function removeNotification(notification) {
                vm.notifications.splice(vm.notifications.indexOf(notification), 1);
            }
        }
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('vm').component('appNotification', {
        templateUrl: 'notification.component.html',
        bindings: {
            notification: '=',
            close: '&'
        },
        controllerAs: 'vm',
        controller: function controller() {
            var vm = this;

            vm.onClose = onClose;

            //////////

            function onClose() {
                vm.close(vm.notification);
            }
        }
    });
})();
'use strict';

angular.module('vm').component('appCookieAgreement', {
    templateUrl: 'cookie-agreement.component.html',
    bindings: {},
    controllerAs: 'vm',
    controller: function controller($cookies) {
        var vm = this;

        vm.step = null;
        vm.$onInit = $onInit;
        vm.onReadMore = onReadMore;
        vm.onNotNow = onNotNow;
        vm.onIAgree = onIAgree;

        function $onInit() {
            var agreeWithCookie = $cookies.get('agreed_with_cookie_policy');

            if (!agreeWithCookie) {
                vm.step = 'show';
            }
        }

        function onReadMore() {
            vm.step = 'show';
        }

        function onNotNow() {
            vm.step = 'notnow';
        }

        function onIAgree() {
            var now = new Date(),
                exp = new Date(now.getFullYear() + 10, now.getMonth(), now.getDate());
            var unix = Math.round(+new Date() / 1000);

            $cookies.put('agreed_with_cookie_policy', unix, {
                expires: exp
            });

            vm.step = null;
        }
    }
});
"use strict";

var LandingTracking = {
    data: {},

    initialize: function initialize() {
        this.collectData();
        this.sendPixel();
        this.updateForms();
    },

    collectData: function collectData() {
        // 1. REQUEST_URI = /welcome/adult?cid=test_cid&pid=somepid
        // 2. SERVER_NAME = some.name.com
        // 3. HTTP_REFERER = http://some.name.com/sdkksa/ccdd?something=ok

        this.data['referrer'] = encodeURIComponent(document.referrer);
        this.data['server_name'] = encodeURIComponent(document.location.hostname);

        var href = document.location.href;
        var len = document.location.protocol.length + 2 + document.location.hostname.length;
        var uri = href.substring(len);
        uri = uri.replace(/.*?(\/.*)/, '$1');

        this.data['request_uri'] = uri;
    },

    findFormItems: function findFormItems() {
        var result = [];
        var items = document.getElementsByName('nextlove_user_short_registration_form[_token]');
        if (items.length > 0) {
            items.forEach(function (item) {
                result.push(item);
            });
        }

        items = document.getElementsByName('nextlove_user_short_registration_form[_token]');
        if (items.length > 0) {
            items.forEach(function (item) {
                result.push(item);
            });
        }

        items = document.getElementsByName('footer_nextlove_user_short_registration_form[_token]');
        if (items.length > 0) {
            items.forEach(function (item) {
                result.push(item);
            });
        }

        return result;
    },

    onTrackingInitialized: function onTrackingInitialized() {
        var event = document.createEvent('Event');
        event.state = 4;
        event.initEvent('digisec:on-tracking-executed', true, false);
        window.dispatchEvent(event);
    },

    updateForms: function updateForms() {
        var self = this;
        setTimeout(function () {

            var inputs = self.findFormItems();
            inputs.forEach(function (input) {
                var name = input.name.replace(/(.*)\[.*\]/, '$1');
                var http = new XMLHttpRequest();
                http.open("POST", '/forms/token/' + name, true);
                http.setRequestHeader("Content-type", "application/json;charset=UTF-8");
                http.onreadystatechange = function () {
                    if (http.readyState === 4) {
                        var response = JSON.parse(http.response);
                        input.value = response.token;
                    }
                };
                http.send();
            });
        }, 100);
    },

    sendPixel: function sendPixel() {
        var self = this,
            http = new XMLHttpRequest();
        http.open("POST", '/api/v4.0/settings/track', true);
        http.setRequestHeader("Content-type", "application/json;charset=UTF-8");
        http.onreadystatechange = function () {
            if (http.readyState === 4) {
                var response = JSON.parse(http.response);
                self.changeLocale(response.locale);
                self.onTrackingInitialized();
            }
        };
        http.send(JSON.stringify(this.data));
    },

    changeLocale: function changeLocale(locale) {
        var newUrl,
            curUrl = window.location.pathname,
            match = curUrl.match(/^\/([a-z]{2}|[a-z]{2}_[A-Z]{2}|zh_Hans_[A-Z]{2})\//);

        if (!curUrl.match(/^\/(([a-z]{2}|[a-z]{2}_[A-Z]{2}|zh_Hans_[A-Z]{2})\/)?(land|blog).*/)) {
            return;
        }

        if (match) {
            if (match[1] === locale) {
                return false;
            }
            newUrl = curUrl.replace(/\/([a-z]{2}|[a-z]{2}_[A-Z]{2}|zh_Hans_[A-Z]{2})\//g, '/' + locale + '/');
        } else {
            newUrl = curUrl.replace(/^(https?.\/\/(\w+\.)+\w+)\/(.*)$/, '$1/' + locale + '/$3');
        }

        window.location.href = newUrl;
    }
};

LandingTracking.initialize();
"use strict";

var LandingAbTest = {
    data: {},

    initialize: function initialize() {
        var self = this;
        window.addEventListener('digisec:on-tracking-executed', function () {
            self.abTestInit();
        });
    },

    abTestInit: function abTestInit() {
        var self = this,
            http = new XMLHttpRequest();
        http.open("POST", '/api/v4.0/settings/lander-ab-test', true);
        http.setRequestHeader("Content-type", "application/json;charset=UTF-8");
        http.onreadystatechange = function () {
            if (http.readyState === 4) {
                var response = JSON.parse(http.response);
                console.log(response);

                if (response['js']) {
                    eval(response['js']);
                }
            }
        };
        http.send();
    }
};

LandingAbTest.initialize();
'use strict';

angular.module('vm.common', ['ngCookies']);
'use strict';

(function () {
    'use strict';

    angular.module('vm.common').component('appBanner', {
        templateUrl: 'app-banner.component.html',
        bindings: {
            type: '='
        },
        controllerAs: 'vm',
        controller: function controller(CONFIG) {
            var vm = this;

            vm.CONFIG = CONFIG;
            vm.showBanner = true;

            vm.close = close;

            //////////

            function close() {
                vm.showBanner = false;

                var els = document.querySelectorAll('.has-app-banner');

                if (els) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = els[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var el = _step.value;

                            el.classList.remove('has-app-banner');
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        }
    });
})();